export default __webpack_public_path__ + "static/media/1685.68ae2927.png";